<script lang="ts" setup>
import { useFormStore } from "@stores/form.store"
import { computed } from "vue"
type Props = {
    title: string
    subTitle?: string
    footerBtn?: boolean
    confirmLabel?: string
    headerBtn?: boolean
    loadingSubmit?: boolean
    horizontalBtn?: boolean
}

withDefaults(defineProps<Props>(), {
    title: "",
    subTitle: "",
    footerBtn: true,
    headerBtn: false,
    confirmLabel: "Suivant",
    loadingSubmit: false,
    horizontalBtn: false,
})

const { cstbRecord } = useFormStore()

const companyLogo = computed(() => {
    return cstbRecord?._id_company?.img?.crop_image || null
})
</script>
<template>
    <BaseCard class="form-card">
        <template #header>
            <div class="form-card__header" v-if="title">
                <div class="flex items-center justify-center gap-2">
                    <h1>
                        {{ title }}
                    </h1>
                    <!-- Logo de l'entreprise partenaire -->
                    <img
                        v-if="companyLogo"
                        :src="companyLogo"
                        class="max-h-24"
                        loading="lazy"
                        alt="Logo de l'entreprise partenaire"
                    />
                </div>
                <h3>{{ subTitle }}</h3>
            </div>
            <slot name="header"></slot>
        </template>
        <template #content>
            <div
                class="form-card__header-btn"
                :data-horizontal="horizontalBtn"
                v-if="headerBtn"
            >
                <BaseButton
                    class="md:w-fit w-full !min-w-fit"
                    label="Retour"
                    severity="secondary"
                    @click="$emit('back')"
                ></BaseButton>
                <BaseButton
                    class="md:w-fit w-full !min-w-fit"
                    :label="confirmLabel"
                    icon="pi pi-arrow-circle-right"
                    icon-pos="right"
                    @click="$emit('submit')"
                ></BaseButton>
            </div>
            <slot></slot>
        </template>
        <template #footer>
            <div
                class="form-card__footer"
                :data-horizontal="horizontalBtn"
                v-if="footerBtn"
            >
                <BaseButton
                    class="md:w-fit w-full !min-w-fit"
                    label="Retour"
                    severity="secondary"
                    @click="$emit('back')"
                ></BaseButton>
                <BaseButton
                    class="md:w-fit w-full !min-w-fit"
                    :label="confirmLabel"
                    icon="pi pi-arrow-circle-right"
                    icon-pos="right"
                    :loading="loadingSubmit"
                    @click="$emit('submit')"
                ></BaseButton>
            </div>
            <slot name="footer"></slot>
        </template>
    </BaseCard>
</template>

<style scoped>
@import "@styles/breakpoints.css";
.form-card {
    border-radius: 0.375rem;
    border: 0.001px solid
        var(--inputOverlay-borderColor, rgba(255, 255, 255, 0));
    background: var(--inputOverlay-background, #fff);

    /* inputOverlay/shadow */
    box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.1);

    --p-card-body-padding: 0;

    padding: 2rem;

    @media (--small-viewport) {
        padding: 2rem 1rem;
    }

    .form-card__header {
        display: flex;
        flex-direction: column;
        gap: 1rem;

        padding-bottom: 1rem;
        h1 {
            color: var(--p-primary-800);
            text-align: center;
            font-size: 1.5rem;
            font-weight: 700;
        }

        h3 {
            color: var(--p-primary-400);
            text-align: center;
            font-size: 1.25rem;
            font-weight: 500;
        }
        border-bottom: 1px solid var(--p-gray-150);
    }

    .form-card__company-logo {
        display: flex;
        justify-content: center;
        align-items: center;

        .company-logo-img {
            width: auto;
            max-height: 100px;
        }
    }

    .form-card__footer {
        display: flex;
        padding: 4.5rem 0rem;
        justify-content: space-between;
        flex-wrap: wrap;
        align-items: center;

        gap: 1rem;

        &:not([data-horizontal="true"]) {
            @media (--small-viewport) {
                padding: 3.5rem 0;
                display: grid !important;
                grid-template-columns: 1fr 1fr;

                &[data-horizontal="true"] {
                    grid-template-columns: 1fr;
                }
            }
        }

        &[data-horizontal="true"] {
            flex-direction: column-reverse !important;
        }
    }

    .form-card__header-btn {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        align-items: center;
        gap: 1rem;

        &:not([data-horizontal="true"]) {
            @media (--small-viewport) {
                display: grid;
                grid-template-columns: 1fr 1fr;
            }
        }

        &[data-horizontal="true"] {
            flex-direction: column-reverse !important;
        }
    }
}
</style>
